/*
 * Created by: cparaschiv
 * Date: 14.08.2013, 13:58
 */

/**
 * @module TS.Log
 * @desc Logging module
 *
 */
TS.Log = TS.Log || {};

(function(){
    'use strict';

    var consoleFunc = {
        'ERROR': 'error',
        'WARN': 'warn',
        'INFO': 'info',
        'TRACE': 'log'
    };
    
    var logToUI = function(msg) {
        var uiConsole = $('#uiConsole');
        var setPosition = function (w) {
            w = w.data('kendoWindow');
            w.setOptions({
                position: {top: $(window).outerHeight() - w.wrapper.outerHeight() - 10, left: 10}
            });
        };
        if (uiConsole.length == 0) {
            uiConsole = $('<div id="uiConsole"></div>')
                .kendoWindow({
                    title: 'Console',
                    appendTo: $('body'),
                    width: 450,
                    height: 200,
                    resizable: true,
                    visible: false,
                    draggable: true,
                    modal: false
                });

            uiConsole.data("kendoWindow").wrapper.css({
                position: 'fixed'
            });

            setTimeout(function() {
                setPosition(uiConsole);
                uiConsole.data('kendoWindow').open();
            }, 100);
            $(window).resize(function() {
                setPosition(uiConsole);
            });
        }
        uiConsole.prepend(msg + '<br/>');
    };

    var logMessage = function(msg, type){
        var m,
            func;

        type = type || 'INFO';
        m = '[' + type + '] ' + msg;
        //func = consoleFunc[type] || 'log';
        if (TS.Log.showInUI)
            logToUI(m);
        func = 'log';
        window.console && console[func](m);
    };

    /** exports TS.Log */
    $.extend(TS.Log, {
        /**
         * In case of IE we may want to show the log info in ui 
         * to avoid using the console
         */
        showInUI: false,

        /**
         * Logs an INFO message.
         * @param msg {string} Message to be logged
         * @static
         */
        info: function(msg){
            logMessage(msg, 'INFO');
        },

        /**
         * Logs a WARN message.
         * @param msg {string} Message to be logged
         * @static
         */
        warn: function(msg){
            logMessage(msg, 'WARN');
        },

        /**
         * Logs an ERROR message.
         * @param msg {string} Message to be logged
         * @static
         */
        error: function(msg){
            logMessage(msg, 'ERROR');
        },

        /**
         * Logs a DEBUG message.
         * @param msg {string} Message to be logged
         * @static
         */
        debug: function(msg){
            logMessage(msg, 'DEBUG');
        },

        /**
         * Logs a TRACE message.
         * @param msg {String} Message to be logged
         * @static
         */
        trace: function(msg){
            logMessage(msg, 'TRACE');
        },

        /**
         * Returns a text description of an {@link http://api.jquery.com/jQuery.ajax/#jqXHR|jqXHR} object
         * @param jqXHR {jqXHR} {@link http://api.jquery.com/jQuery.ajax/#jqXHR|jqXHR}
         * @returns {string}
         * @static
         */
        getXHRInfo: function(jqXHR){
            var ret = '',
                props = ['status', 'statusText', 'responseText'];

            if (!jqXHR)
                return ret;

            $.each(props, function(idx, propName){
                ret += propName + ': ' + jqXHR[propName] + '; ';
            });

            return ret;
        }
    });

    TS.log = TS.Log.debug;
    TS.trace = TS.Log.trace;
})();
